import { splitByBoolean } from "../../../../../../common/util/Array/orderByBoolean";
import { Markdown } from "../../../../Markdown";
import { replyToMessageKey } from "../../../../Markdown/CodeRender";

export function MessageMarkdown({
    text,
    noLinkShadow,
}: {
    text: string;
    noLinkShadow?: boolean;
}) {
    const [mainText, replyText] = splitByBoolean(
        text.split("```"),
        text => !text.startsWith(replyToMessageKey)
    ).map(t => t.join(""));

    return (
        <>
            {replyText && (
                <Markdown
                    source={"```" + replyText + "```"}
                    noParagraphMarginBottom
                    noLinkShadow={noLinkShadow}
                />
            )}
            {mainText.split(/\n\n+/g).map((t, i) => (
                <Markdown
                    key={i}
                    style={i > 0 ? { marginTop: 30 } : {}}
                    source={t}
                    noParagraphMarginBottom
                    noLinkShadow={noLinkShadow}
                />
            ))}
        </>
    );
}

